import { render, staticRenderFns } from "./OfferSynthesis.vue?vue&type=template&id=1f334c80&scoped=true&"
import script from "./OfferSynthesis.vue?vue&type=script&lang=js&"
export * from "./OfferSynthesis.vue?vue&type=script&lang=js&"
import style0 from "./OfferSynthesis.vue?vue&type=style&index=0&id=1f334c80&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f334c80",
  null
  
)

export default component.exports